/**
 * Kanto Korner - Animations & Interactions
 * Pokemon Trading Cards E-commerce
 */

(function() {
  'use strict';

  // ============================================
  // SCROLL ANIMATIONS (Intersection Observer)
  // ============================================
  const animateOnScroll = function() {
    const elements = document.querySelectorAll('.kanto-animate');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      // Fallback for older browsers
      elements.forEach(function(el) {
        el.classList.add('animated');
      });
    }
  };

  // ============================================
  // PARALLAX EFFECT ON HERO
  // ============================================
  const initParallax = function() {
    const hero = document.querySelector('.kanto-hero');
    if (!hero) return;

    const heroContent = hero.querySelector('.kanto-hero__content');
    const particles = hero.querySelector('.kanto-hero__particles');

    let ticking = false;

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          const scrolled = window.pageYOffset;
          const heroHeight = hero.offsetHeight;

          if (scrolled < heroHeight) {
            const parallaxValue = scrolled * 0.4;
            const opacityValue = 1 - (scrolled / heroHeight);

            if (heroContent) {
              heroContent.style.transform = 'translateY(' + parallaxValue + 'px)';
              heroContent.style.opacity = Math.max(0, opacityValue);
            }

            if (particles) {
              particles.style.transform = 'translateY(' + (parallaxValue * 0.5) + 'px)';
            }
          }

          ticking = false;
        });

        ticking = true;
      }
    });
  };

  // ============================================
  // PRODUCT CARD HOLOGRAPHIC EFFECT
  // ============================================
  const initHoloEffect = function() {
    const cards = document.querySelectorAll('.kanto-product-card, .product-card');

    cards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        const rotateX = (y - centerY) / 20;
        const rotateY = (centerX - x) / 20;

        card.style.transform = 'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-5px)';
      });

      card.addEventListener('mouseleave', function() {
        card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) translateY(0)';
      });
    });
  };

  // ============================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================
  const initSmoothScroll = function() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  };

  // ============================================
  // COUNTER ANIMATION
  // ============================================
  const animateCounter = function(element, target, duration) {
    let start = 0;
    const increment = target / (duration / 16);

    const updateCounter = function() {
      start += increment;
      if (start < target) {
        element.textContent = Math.floor(start);
        requestAnimationFrame(updateCounter);
      } else {
        element.textContent = target;
      }
    };

    updateCounter();
  };

  // ============================================
  // LAZY LOAD VIDEOS
  // ============================================
  const initLazyVideos = function() {
    const videos = document.querySelectorAll('video[data-src]');

    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const video = entry.target;
            video.src = video.dataset.src;
            video.load();
            videoObserver.unobserve(video);
          }
        });
      }, {
        rootMargin: '100px'
      });

      videos.forEach(function(video) {
        videoObserver.observe(video);
      });
    }
  };

  // ============================================
  // NAVBAR SCROLL EFFECT
  // ============================================
  const initNavbarScroll = function() {
    const header = document.querySelector('.header, #header-group');
    if (!header) return;

    let lastScroll = 0;

    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 100) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      // Hide/show on scroll direction
      if (currentScroll > lastScroll && currentScroll > 200) {
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }

      lastScroll = currentScroll;
    });
  };

  // ============================================
  // TOAST NOTIFICATIONS
  // ============================================
  window.kantoToast = function(message, type) {
    type = type || 'info';

    const toast = document.createElement('div');
    toast.className = 'kanto-toast kanto-toast--' + type;
    toast.innerHTML = '<span>' + message + '</span>';

    // Add styles if not present
    if (!document.querySelector('.kanto-toast-styles')) {
      const style = document.createElement('style');
      style.className = 'kanto-toast-styles';
      style.textContent = '\n        .kanto-toast {\n          position: fixed;\n          bottom: 20px;\n          right: 20px;\n          padding: 1rem 1.5rem;\n          background: #0a2c47;\n          color: white;\n          border-radius: 8px;\n          box-shadow: 0 4px 20px rgba(0,0,0,0.2);\n          z-index: 99999;\n          animation: toast-in 0.3s ease forwards;\n          max-width: 300px;\n        }\n        .kanto-toast--success { background: #10b981; }\n        .kanto-toast--error { background: #ef4444; }\n        .kanto-toast--warning { background: #f59e0b; }\n        @keyframes toast-in {\n          from { transform: translateX(100%); opacity: 0; }\n          to { transform: translateX(0); opacity: 1; }\n        }\n        @keyframes toast-out {\n          from { transform: translateX(0); opacity: 1; }\n          to { transform: translateX(100%); opacity: 0; }\n        }\n      ';
      document.head.appendChild(style);
    }

    document.body.appendChild(toast);

    setTimeout(function() {
      toast.style.animation = 'toast-out 0.3s ease forwards';
      setTimeout(function() {
        toast.remove();
      }, 300);
    }, 3000);
  };

  // ============================================
  // KONAMI CODE EASTER EGG
  // ============================================
  const initKonamiCode = function() {
    const konamiCode = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    let konamiIndex = 0;

    document.addEventListener('keydown', function(e) {
      if (e.key === konamiCode[konamiIndex]) {
        konamiIndex++;
        if (konamiIndex === konamiCode.length) {
          triggerCardRain();
          konamiIndex = 0;
        }
      } else {
        konamiIndex = 0;
      }
    });
  };

  const triggerCardRain = function() {
    const cards = ['🃏', '⭐', '✨', '💎', '🌟'];
    const container = document.createElement('div');
    container.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999;overflow:hidden;';
    document.body.appendChild(container);

    for (let i = 0; i < 50; i++) {
      setTimeout(function() {
        const card = document.createElement('div');
        card.textContent = cards[Math.floor(Math.random() * cards.length)];
        card.style.cssText = '\n          position: absolute;\n          top: -50px;\n          left: ' + Math.random() * 100 + '%;\n          font-size: ' + (20 + Math.random() * 30) + 'px;\n          animation: card-fall ' + (3 + Math.random() * 2) + 's linear forwards;\n        ';
        container.appendChild(card);
      }, i * 100);
    }

    // Add animation style
    const style = document.createElement('style');
    style.textContent = '@keyframes card-fall { to { transform: translateY(110vh) rotate(720deg); } }';
    document.head.appendChild(style);

    setTimeout(function() {
      container.remove();
      style.remove();
    }, 8000);

    window.kantoToast('Vous avez trouve le code secret ! 🎉', 'success');
  };

  // ============================================
  // ADD TO CART ANIMATION
  // ============================================
  const initAddToCartAnimation = function() {
    document.addEventListener('click', function(e) {
      const addToCartBtn = e.target.closest('[data-add-to-cart], .add-to-cart-button, [name="add"]');
      if (!addToCartBtn) return;

      // Create flying pokeball
      const pokeball = document.createElement('div');
      pokeball.innerHTML = '<svg viewBox="0 0 100 100" width="30" height="30"><circle cx="50" cy="50" r="48" fill="#E3350D"/><rect x="0" y="46" width="100" height="8" fill="#0a2c47"/><rect x="0" y="50" width="100" height="48" fill="white"/><circle cx="50" cy="50" r="15" fill="white" stroke="#0a2c47" stroke-width="6"/></svg>';
      pokeball.style.cssText = '\n        position: fixed;\n        z-index: 99999;\n        pointer-events: none;\n        transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n      ';

      const rect = addToCartBtn.getBoundingClientRect();
      pokeball.style.left = rect.left + rect.width / 2 - 15 + 'px';
      pokeball.style.top = rect.top + rect.height / 2 - 15 + 'px';

      document.body.appendChild(pokeball);

      // Animate to cart icon
      const cartIcon = document.querySelector('.header__icon--cart, [data-cart-icon], .cart-icon');
      if (cartIcon) {
        const cartRect = cartIcon.getBoundingClientRect();
        setTimeout(function() {
          pokeball.style.left = cartRect.left + cartRect.width / 2 - 15 + 'px';
          pokeball.style.top = cartRect.top + cartRect.height / 2 - 15 + 'px';
          pokeball.style.transform = 'scale(0.5)';
          pokeball.style.opacity = '0';
        }, 50);
      }

      setTimeout(function() {
        pokeball.remove();
      }, 900);
    });
  };

  // ============================================
  // INITIALIZE ALL
  // ============================================
  const init = function() {
    animateOnScroll();
    initParallax();
    initHoloEffect();
    initSmoothScroll();
    initLazyVideos();
    initNavbarScroll();
    initKonamiCode();
    initAddToCartAnimation();

    // Re-initialize on Shopify section reload
    document.addEventListener('shopify:section:load', function() {
      animateOnScroll();
      initHoloEffect();
    });
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
